import React from "react";
import {Panel, PanelBody} from "./../components/panel/panel.jsx";
import {Api} from "./../app-controller.js";

class Inventory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            previa: false,
            previa_url: "",
            working: true,
            modalState: false,
            info_actividad:{evento:{},documentos:[]}
        };
        //this.formatDate = this.formatDate.bind(this);
    }

   /*  formatDate(fecha){
        if(fecha!==undefined){
            return fecha.split("-").reverse().join("-").replaceAll("-","/");
        }
    } */

    componentDidMount() {
 
        let grid = {
            source: "app/getInventoryList",
            target: "#myGrid",
            tableClass: "table table-striped m-b-0 table-hover",
            rowsPerPage: [
                5, 10, 25, 50, 100
            ],
            progressText: "Cargando datos",
            rows: {
                razon_social: {
                  label: "Establecimiento"
                },
                nombre_comercial: {
                  label: "Nombre comercial"
                },
                clase_producto: {
                    label: "Tipo de clase de producto"
                },
                tipo_movimiento: {
                    label: "Movimiento"
                },
                tipo_movimiento_producto: {
                    label: "Tipo_movimiento_producto"
                }               
            },
            buttons: [
                {
                    iconClass: "fa fa-list",
                    btnClass: "btn bg-gradient-green",
                    btnClick: (data) => {
                        /*  Api.loading(true);       
                        Api.fetch("app/getInformacionActividad/", {id:data.id}, "POST")
                          .then((data) => {
                            this.setState({ info_actividad: data });
                            this.setState({ modalState: true });
                          })
                          .then(() => {
                            Api.loading(false);
                            this.setState({ working: false });
                          });  */
                      },
                    render: (me, data) => {
                        
                    }
                },
            ]
        }

        let mi_grid = Api.grid(grid);
        
        let busqueda = Api.form({
            target: "#busqueda",
            onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },
            render: form => {

                // Cargamos el combo de tipo_evento 
                 Api.fetch("app/getEstablishmentsLog/")
                .then((data) => {
                  let establecimientos = data;
                  let option_est = "<option value=0>Seleccione establecimiento</option>";
                  for (let p in establecimientos) {
                    option_est += `<option value="${establecimientos[p].id}">
                          ${establecimientos[p].razon_social}
                      </option>`;
                  }
                  form.querySelector("#establecimiento_id").innerHTML = option_est;
                });

                
                // Fin de la carga 

                // Cargamos el combo de tipo mov 
                let tipo_mov = Api.loadCatalogue("cat_movimiento")
                let option_e = "<option value=0>Seleccione movimiento</option>";
                for (let p in tipo_mov) {
                    option_e += `<option value="${tipo_mov[p].id}">
                        ${tipo_mov[p].descripcion}
                    </option>`;
                }
                form.querySelector("#movimiento_id").innerHTML = option_e;
                // Fin de la carga  

                // Cargamos el combo de tipo mov prod
                let tipo_mov_prod = Api.loadCatalogue("cat_tipo_movimiento_producto")
                let option_s = "<option value=0>Seleccione tipo de movimiento producto</option>";
                for (let p in tipo_mov_prod) {
                    option_s += `<option value="${tipo_mov_prod[p].id}">
                        ${tipo_mov_prod[p].descripcion}
                    </option>`;
                }
                form.querySelector("#tipo_movimiento_producto_id").innerHTML = option_s;
                //Fin de la carga 
             },

            elementClass: "form-control",
            elements: [
                {
                  select: {
                    type: "text",
                    name: "establecimiento_id",
                    label: "Establecimiento",
                    placeHolder: "",
                    cols: 6,
                    value: ""
                }
                }, {
                    input: {
                        type: "text",
                        name: "nombre_comercial",
                        label: "Ingresa el nombre comercial del producto",
                        placeHolder: "Nombre comercial",
                        cols: 6,
                        value: ""
                    }
                },{
                    select: {
                        type: "text",
                        name: "movimiento_id",
                        label: "Tipo movimiento",
                        placeHolder: "Tipo movimiento",
                        cols: 6,
                        value: ""
                    }
                },{
                    select: {
                        type: "text",
                        name: "tipo_movimiento_producto_id",
                        label: "Tipo sitio",
                        placeHolder: "Tipo movimiento producto",
                        cols: 6,
                        value: ""
                    }
                },  
               /*  {
                    input: {
                        type: "date",
                        name: "fecha_movimiento",
                        label: "Ingresa la fecha",
                        placeHolder: "Fecha movimiento",
                        cols: 6,
                        value: "",
                        autoComplete:"off",
                      
                    }
                } */
            ]
        }); 
    }

    render() {
        return (
            <div>
                <ol className="breadcrumb float-xl-right">
                    <li className="breadcrumb-item">
                        Inicio
                    </li>
                    <li className="breadcrumb-item active">
                        Inventario
                    </li>
                </ol>
                <h1 className="page-header">
                    Inventario
                </h1>
                <Panel>
                    <PanelBody>
                        <div className="row">
                            <div className="col-sm-12">
                                 <fieldset>
                                    <div id="busqueda"></div>
                                </fieldset> 
                                <div id="myGrid"></div>
                            </div>
                        </div>

                    </PanelBody>
                </Panel>
           {/*     <div className="hide">
                      <fieldset id="cargaDocs"></fieldset>
                </div>
                <Modal
          isOpen={this.state.modalState}
          tabIndex="-1"
          style={{ maxWidth: "100%", width: "85%" }}
        >
          <ModalHeader
            toggle={() => {
              this.setState({ modalState: false });
              
            }}
          >
          </ModalHeader>
          <ModalBody>

          <div className={this.state.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.state.working ? "hide" : ""}>
               <div className="row">
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Tipo de evento</div>

                      <div className="stats-desc">
                        <h5>{this.state.info_actividad.evento.tipo_evento}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Tipo de sitio</div>

                      <div className="stats-desc">
                        <h5>{this.state.info_actividad.evento.tipo_sitio}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Fecha</div>

                      <div className="stats-desc">
                        <h5>{this.formatDate(this.state.info_actividad.evento.fecha)}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Hora</div>

                      <div className="stats-desc">
                        <h5>{this.timeString(this.state.info_actividad.evento.hora)}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr /> 
              <fieldset className="col-md-12">
                <legend>Datos generales</legend>

                <div className="row">
                  <div className="form-group col-md-12">
                    <label>Tema</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.nombre}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Objetivo</label>
                    <textarea class="form-control" rows="3">{this.state.info_actividad.evento.objetivo}</textarea> 
                  </div>

                  <div className="form-group col-md-4">
                    <label>Tipo de evento</label>
                    <div className="form-control">
                        {this.state.info_actividad.evento.tipo_evento}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Tipo de sitio</label>
                    <div className="form-control">
                        {this.state.info_actividad.evento.tipo_sitio}
                    </div>
                  </div>

                  <div className="form-group col-md-2">
                    <label>Cantidad de participantes hombres</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.cant_hombres}
                    </div>
                  </div>

                  <div className="form-group col-md-2">
                    <label>Cantidad de participantes mujeres</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.cant_mujeres}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Nombre</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.usuario_participante}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Tipo de participación</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.tipo_participacion}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Lugar</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.lugar}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Fecha</label>
                    <div className="form-control">
                      {this.formatDate(this.state.info_actividad.evento.fecha)}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Hora</label>
                    <div className="form-control">
                    {this.timeString(this.state.info_actividad.evento.hora)}
                    </div>
                  </div>

                </div>
              </fieldset>
               <hr />
              <fieldset className="col-md-12">
                <legend>Documentación</legend>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">Vista previa</th>
                        <th className="text-center">Documento</th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.working ? "hide" : "show"}>
                      {this.state.info_actividad.documentos.map((ev) => (
                        <tr key={ev.id}>
                          
                          <td className="text-center">
                            <img
                              alt="Vista previa"
                              className="rounded btn"
                              data-file={
                                Api.url + `app/documentoA/?id=${ev.id}`
                              }
                              onClick={this.handlePrevia}
                              width="60"
                              src={
                                Api.url + `app/documentoA/?id=${ev.id}&thumb=1`
                              }
                            />
                          </td>
                          <td className="text-center">Documento soporte</td>
                          <td className="text-center">
                            <div className="btn-group">
                              <a
                                href={
                                  Api.url +
                                  `app/documentoA/?id=${ev.id}&download=1`
                                }
                                className="btn btn-primary"
                              >
                                <i className="fas fa-file-download"></i>
                              </a>
                            
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset>      
            </div>
          </ModalBody>
        </Modal>

        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div> */}
            </div>
        );
    }

}

export default Inventory;
